import React from "react";

export const StatCard = ({ label, value, sub, icon: Icon, accent = "emerald", testid }) => {
  const accents = {
    emerald: "bg-emerald-50 text-emerald-600",
    blue: "bg-blue-50 text-blue-600",
    red: "bg-red-50 text-red-600",
    indigo: "bg-indigo-50 text-indigo-600",
  };
  return (
    <div
      data-testid={testid}
      className="rounded-xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition-shadow duration-200 p-4 sm:p-5"
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-[11px] sm:text-xs tracking-[0.04em] uppercase font-semibold text-slate-500 leading-tight">
          {label}
        </p>
        <span className={`h-8 w-8 sm:h-9 sm:w-9 shrink-0 rounded-lg flex items-center justify-center ${accents[accent]}`}>
          <Icon className="h-4 w-4 sm:h-[18px] sm:w-[18px]" strokeWidth={2} />
        </span>
      </div>
      <p className="font-heading font-bold text-slate-900 text-2xl sm:text-3xl mt-3 sm:mt-4 tracking-tight leading-none break-words">
        {value}
      </p>
      {sub && <p className="text-xs sm:text-sm text-slate-400 mt-1 truncate">{sub}</p>}
    </div>
  );
};
